import { EventEmitter } from '@angular/core';
var TabsComponent = /** @class */ (function () {
    function TabsComponent() {
        this.onTabSelect = new EventEmitter();
    }
    TabsComponent.prototype.selectTab = function (index) {
        // Unselect previous selected tab
        this.tabs.forEach(function (tab) { return tab.isActive = false; });
        // Set current tab as active
        this.tabs[index].isActive = true;
        this.onTabSelect.emit(this.tabs[index]);
    };
    return TabsComponent;
}());
export { TabsComponent };
